/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Sets_DoneInputs */

const en_us2_workout_sets_done = /** @type {(inputs: Workout_Sets_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets done`)
};

const pt_br2_workout_sets_done = /** @type {(inputs: Workout_Sets_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries feitas`)
};

const es_419_workout_sets_done = /** @type {(inputs: Workout_Sets_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Series hechas`)
};

const pt_pt2_workout_sets_done = /** @type {(inputs: Workout_Sets_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries feitas`)
};

const fr_fr2_workout_sets_done = /** @type {(inputs: Workout_Sets_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries faites`)
};

const de_de2_workout_sets_done = /** @type {(inputs: Workout_Sets_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erledigte Sätze`)
};

const it_it2_workout_sets_done = /** @type {(inputs: Workout_Sets_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie fatte`)
};

/**
* | output |
* | --- |
* | "Sets done" |
*
* @param {Workout_Sets_DoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_sets_done = /** @type {((inputs?: Workout_Sets_DoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Sets_DoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_sets_done(inputs)
	if (locale === "es-419") return es_419_workout_sets_done(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_sets_done(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_sets_done(inputs)
	if (locale === "de-DE") return de_de2_workout_sets_done(inputs)
	if (locale === "it-IT") return it_it2_workout_sets_done(inputs)
	return en_us2_workout_sets_done(inputs)
});
export { workout_sets_done as "workout.sets_done" }